<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page

========================================================================================== -->

<template>
  <div id="page-user-view">

    <vs-alert :active.sync="userNotFound" color="danger" title="User Not Found">
      <span>User record with id: {{ $route.params.userId }} not found. </span>
      <span>
        <span>Check </span>
        <router-link to="/" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <div v-if="userData">
      <div class="vx-row match-height" id="user-data">
        <div class="vx-col w-4/5">
          <vx-card class="mb-base" title="Account">

            <!-- Avatar -->
            <div class="vx-row">

              <!-- Avatar Col -->
              <div class="vx-col" id="avatar-col">
                <div class="img-container mb-4">
                  <img :src="userData.photoURL" class="rounded w-full"/>
                </div>
              </div>

              <!-- Information - Col 1 -->
              <div class="vx-col flex-1" id="account-info-col-1">
                <table>
                  <tr>
                    <td class="font-semibold">First Name</td>
                    <td>{{ userData.first_name }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Last Name</td>
                    <td>{{ userData.last_name }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Username</td>
                    <td>{{ userData.username }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Role</td>
                    <td>{{ userData.role | title('_') }}</td>
                  </tr>
                </table>
              </div>
              <!-- /Information - Col 1 -->

              <!-- Information - Col 2 -->
              <div class="vx-col flex-1" id="account-info-col-2">
                <table>

                  <tr>

                  </tr>
                </table>
              </div>
              <!-- /Information - Col 2 -->
              <div class="vx-col w-full flex" id="account-manage-buttons">
                <vs-button :to="{name: 'app-user-edit', params: { userId: $route.params.userId }}" class="mr-4"
                           icon="icon-edit"
                           icon-pack="feather">Edit
                </vs-button>
                <!--- <vs-button @click="deactivateUser" v-if="authData.active" color="danger" icon="icon-pause"
                           icon-pack="feather"
                           type="border">
                  Deactivate User
                </vs-button>
                <vs-button @click="activate_user" v-else color="danger" icon="icon-pause" icon-pack="feather"
                           type="border">
                  Activate User
                </vs-button> --->
              </div>

            </div>

          </vx-card>
        </div>

        <div class="vx-col w-1/5">
          <vx-card class="mb-base" title="User Actions">
            <div class="vx-row">
              <div class="vx-col w-full">
                <vs-button class="w-full my-2 font-bold" color="success" icon="icon-book" icon-pack="feather"
                           type="filled"
                           @click="addStudentCourseSearchActive = true;">Assign Student to Course
                </vs-button>
                <vs-button class="w-full my-2 font-bold" color="warning" icon="icon-tag" icon-pack="feather"
                           type="filled"
                           @click="addStudentGroupManagerActive = true;">Group Manager
                </vs-button>
              </div>
            </div>
          </vx-card>
        </div>

      </div>
      <div class="vx-row match-height">
        <div class="vx-col w-full sm:w-2/2 md:w-2/2 lg:w-1/3 xl:w-1/3  mb-base">
          <vx-card v-if="activeCourseData !== null"
                   :style="activeCourseData ? {'background-image': 'url(' +  activeCourseData.thumbnail + ')',  'background-size': 'cover', } : ''"
                   class="overlay-card overflow-hidden">
            <template slot="no-body">
              <div class="p-6" v-if="activeCourseData.selected" style="backdrop-filter: blur(10px);">
                <div class="vx-row ">
                  <div class="vx-col w-2/3 flex flex-wrap content-center welcome-col">
                    <h3 class="my-2 text-white w-full">Current Active Course</h3>
                    <h1 class="my-2 text-white w-full">{{ activeCourseData.name }}</h1>
                    <p class="my-2 text-white w-full">The user is currently practicing {{ activeCourseData.name }}</p>
                    <vs-progress
                      :percent="coursePercent"
                      class="block my-2 shadow-md" color="success"></vs-progress>
                  </div>
                  <div class="vx-col w-1/3 flex flex-wrap content-center course-col">
                    <img
                      :src="activeCourseData.thumbnail !== null ? activeCourseData.thumbnail : 'https://cdn.discordapp.com/attachments/746242308084858900/848762736255172679/default-placeholder.png'"
                      class="rounded image-course" width="100%" height="100%" draggable="false">
                  </div>
                </div>
              </div>
              <div v-if="activeCourseData.selected === false" class="p-6">
                <div class="vx-col w-full flex flex-wrap content-center ">
                  <h1 class="my-2 text-white">No Active Course Selected</h1>
                  <p class="my-2 text-white">The user has not selected an active course yet.</p>
                </div>
              </div>
            </template>
          </vx-card>
          <div class="vx-col w-full" v-else>
            <single-card-skeleton/>
          </div>
        </div>
        <div class="vx-col w-full sm:w-2/2 md:w-2/2 lg:w-2/3 xl:w-2/3  mb-base">
          <vx-card>
            <h2>Course Completion</h2>
            <div class="flex justify-center items-center">
              <vs-progress class="mr-4 ml-2" :height="12" :percent="coursePercent" color="success"></vs-progress>
              <h1 class="ml-4 mr-4" style="font-size: 3rem">{{ coursePercent }}%</h1>
            </div>
          </vx-card>
        </div>
      </div>
      <div class="vx-row ">
        <div class="vx-col w-full">
          <list-subscriptions :key="subTableKey" :userId="userData.id" :filterUsers="false"/>
        </div>
      </div>

      <vs-popup :active.sync="addStudentCourseSearchActive" title="Search for Course by Name">

        <vs-table :data="addStudentCourseSearchResults" :sst="true" max-items="5" search
                  @search="addStudentCourseSearch">
          <template slot="header">
            <h3>Courses</h3>
          </template>

          <template slot="thead">
            <vs-th>Id</vs-th>
            <vs-th>Name</vs-th>
            <vs-th>Action</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr v-for="(attach) in data" :key="attach.id">

              <vs-td :data="attach.id">
                {{ attach.id }}
              </vs-td>

              <vs-td :data="`${attach.name}`">
                <div class="flex align-middle items-center">
                  <img :src="attach.thumbnail" class="rounded mr-3" width="40px">
                  {{ `${attach.name}` }}
                </div>
              </vs-td>

              <vs-td>
                <vs-button color="primary" size="small" type="border" @click="addStudentToCourseOptions(attach)">
                  Assign
                </vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vs-popup>
      <vs-popup :active.sync="addStudentCourseAssignActive" :title="`Assign Course To User`">
        <div class="mb-4">
          <h6>Choose Subscription Expiry</h6>
          <datepicker :inline="true" placeholder="Select Date" v-model="addStudentCourseAssignCalendar" class="datepicker-user-popup mt-4"></datepicker>
          <ul class="flex mt-5" :key="addStudentCourseAssignKey">
            <li>
              <vs-radio v-model="addStudentCourseAssignDuration" @input="calculateCalendarDate" vs-value="1" class="mr-4">1 Month</vs-radio>
            </li>
            <li>
              <vs-radio v-model="addStudentCourseAssignDuration" @input="calculateCalendarDate" vs-value="3" class="mr-4">3 Months</vs-radio>
            </li>
            <li>
              <vs-radio v-model="addStudentCourseAssignDuration" @input="calculateCalendarDate" vs-value="6" class="mr-4">6 Months</vs-radio>
            </li>
            <li>
              <vs-radio v-model="addStudentCourseAssignDuration" @input="calculateCalendarDate" vs-value="12" class="mr-4">1 Year</vs-radio>
            </li>
          </ul>
        </div>
        <p class="text-danger font-bold " v-if="addStudentCourseAssignCalendar === null">You Must Choose A
          Subscription
          Duration</p>

        <vs-button color="primary" type="filled"
                   @click="addStudentToCourseEnroll(addStudentCourseAssign)"
                   v-if="addStudentCourseAssignCalendar">Assign Student
        </vs-button>

      </vs-popup>

      <vs-popup :active.sync="addStudentGroupManagerActive" title="Group Manager">

        <vs-table :data="addStudentGroupSearchResults" :sst="true" max-items="3" search
                  @search="addStudentGroupSearch">
          <template slot="header">
            <h3>Search Groups</h3>
          </template>

          <template slot="thead">
            <vs-th>Id</vs-th>
            <vs-th>Name</vs-th>
            <vs-th>Action</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr v-for="(attach) in data" :key="attach.id">

              <vs-td :data="attach.id">
                {{ attach.id }}
              </vs-td>

              <vs-td :data="`${attach.name}`">
                <div class="flex align-middle items-center">
                  <vs-avatar :color="attach.color" :text="attach.name.charAt(0).toUpperCase()"  class="flex-shrink-0 mr-2"  size="30px" />
                  {{ `${attach.name}` }}
                </div>
              </vs-td>

              <vs-td>
                <vs-button color="primary" size="small" type="border" @click="addStudentToGroup(attach)">
                  Assign
                </vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>

        <vs-divider/>
        <vs-table :data="groupData"  max-items="3" search @search="addStudentCourseSearch" :key="addStudentGroupKey" pagination>
          <template slot="header">
            <h3>User Groups</h3>
          </template>

          <template slot="thead">
            <vs-th>Id</vs-th>
            <vs-th>Name</vs-th>
            <vs-th>Action</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr v-for="(attach) in data" :key="attach.id">

              <vs-td :data="attach.id">
                {{ attach.id }}
              </vs-td>

              <vs-td :data="`${attach.name}`">
                <div class="flex align-middle items-center">
                  <vs-avatar :color="attach.color" :text="attach.name.charAt(0).toUpperCase()"  class="flex-shrink-0 mr-2"  size="30px" />
                  {{ `${attach.name}` }}
                </div>
              </vs-td>

              <vs-td>
                <vs-button color="primary" size="small" type="border" @click="removeStudentFromGroup(attach)">
                  Remove
                </vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>


      </vs-popup>

    </div>
  </div>
</template>

<script>
import DashboardStatisticsCardLine from '@/components/statistics-cards/DashboardStatisticsCardLine.vue'
import ListSubscriptions from '@/views/management/subscriptions/subscription-list/ListSubscriptions.vue'
import SingleCardSkeleton from '@/components/skeleton-loading/SingleCardSkeleton'
import Datepicker from 'vuejs-datepicker'

export default {
  components: {
    DashboardStatisticsCardLine,
    ListSubscriptions,
    SingleCardSkeleton,
    Datepicker
  },
  data () {
    return {
      userData: null,
      groupData: [],
      authData: null,

      coursePercent: 0,
      userNotFound: false,
      userProgress: null,
      activeCourseData: null,


      addStudentCourseSearchActive: false,
      addStudentCourseAssignActive: false,
      addStudentCourseSearchResults: [],
      addStudentCourseAssign: {},
      addStudentCourseAssignDuration: null,
      addStudentCourseAssignCalendar: null,
      addStudentCourseAssignKey: 0,
      subTableKey: 0,

      addStudentGroupManagerActive: false,
      addStudentGroupSearchResults: [],
      addStudentGroupKey: 0


    }
  },
  methods: {
    calculateCalendarDate () {
      const date = new Date()
      const months = parseInt(this.addStudentCourseAssignDuration)
      date.setMonth(date.getMonth() + months)
      this.addStudentCourseAssignCalendar = date
    },
    deactivateUser () {
      this.$vs.loading()
      const pl = {
        active: false
      }
      this.$http.post(`users/${this.userData.id}`, pl)
        .then(response => {
          if (response.data.data) {
            this.$vs.loading.close()
            this.userProgress = response.data.data
            this.$vs.notify({
              color: 'danger',
              title: 'User Deactivated',
              text: 'The following user has been deactivated'
            })
          }
        })
        .catch(() => {
          this.$vs.loading.close()
          this.$vs.notify({
            color: 'Error',
            title: 'User Not Deactivated',
            text: 'The following user has not been deactivated'
          })
        })
    },
    loadUserProgress () {

      if (this.userData.active_course) {

        this.$http.get(`progress/user/specific/@me/course/progress?id=${this.userData.active_course.id}`)
          .then(response => {
            this.coursePercent = response.data.data.completion_percent
          })

        this.$http.get(`courses/${this.userData.active_course}`)
          .then(response => {
            if (response.status === 200) {
              response.data.data.selected = true
              this.activeCourseData = response.data.data
            }
          }).catch(() => {})

      } else {
        this.activeCourseData = {
          selected: false
        }
      }

    },
    addStudentCourseSearch (term) {
      this.$http.get(`courses?search=${term}&amount=3`)
        .then(response => {
          if (response.data) {
            this.addStudentCourseSearchResults = response.data.data
          }
        })
    },
    addStudentToCourseOptions (id) {

      this.addStudentCourseSearchActive = false
      this.addStudentCourseAssignActive = true
      this.addStudentCourseAssign = id

    },
    addStudentToCourseEnroll (course) {

      this.$vs.loading()

      if (!this.addStudentCourseAssignCalendar) {
        this.$vs.notify({
          color: 'danger',
          title: 'Failed to create Subscription',
          text: 'Please provide subscription duration.',
          icon: 'feather',
          iconPack: 'icon-x-circle',
          position: 'top-right'
        })
        return this.$vs.loading.close()
      }

      const pl = {
        user_id: this.userData.id,
        course_id: course.id,
        status: 'active'
      }

      pl.ending_date = this.addStudentCourseAssignCalendar.getTime()

      this.$http.post('subscriptions/create', pl)
        .then(response => {
          this.$vs.loading.close()

          if (response.status === 200) {
            return this.$vs.notify({
              color: 'success',
              title: 'Subscription Created',
              text: 'You have successfully created a subscription',
              icon: 'feather',
              iconPack: 'icon-check-circle',
              position: 'top-right'
            })
          }

        }).catch(exception => {
          this.$vs.loading.close()
          return this.$vs.notify({
            color: 'danger',
            title: 'Failed to create Subscription',
            text: exception.response.data.error.description,
            icon: 'feather',
            iconPack: 'icon-x-circle',
            position: 'top-right'
          })
        })

      this.subTableKey++
      this.addStudentCourseAssignActive = false
      this.addStudentCourseSearchActive = true

    },
    addStudentGroupSearch (term) {
      this.addStudentGroupSearchResults = []
      this.$http.get(`groups?search=${term}&amount=3`)
        .then(response => {
          if (response.data) {
            this.addStudentGroupSearchResults = response.data.data
          }
        })
    },
    addStudentToGroup (group) {
      this.$http.post(`users/${this.userData.id}/groups?id=${group.id}`)
        .then(response => {
          if (response.data) {
            this.loadGroupData(response.data.data.groups)
            return this.$vs.notify({
              title: 'Added User To Group',
              text: `Added ${this.userData.first_name} to ${group.name}`,
              color: 'success',
              iconPack: 'feather',
              position: 'top-right',
              icon: 'icon-check-circle'
            })
          }
        }).catch(exception => {
          this.$vs.loading.close()
          return this.$vs.notify({
            color: 'danger',
            title: 'Failed to Add User',
            text: exception.response.data.error.description,
            icon: 'feather',
            iconPack: 'icon-x-circle',
            position: 'top-right'
          })
        })
    },
    removeStudentFromGroup (group) {
      this.$http.delete(`users/${this.userData.id}/groups?id=${group.id}`)
        .then(response => {
          if (response.data) {
            this.loadGroupData(response.data.data.groups)
            return this.$vs.notify({
              title: 'Removed User To Group',
              text: `Removed ${this.userData.first_name} to ${group.name}`,
              color: 'success',
              iconPack: 'feather',
              position: 'top-right',
              icon: 'icon-check-circle'
            })
          }
        }).catch(exception => {
          this.$vs.loading.close()
          return this.$vs.notify({
            color: 'danger',
            title: 'Failed to Remove User',
            text: exception.response.data.error.description,
            icon: 'feather',
            iconPack: 'icon-x-circle',
            position: 'top-right'
          })
        })
    },
    loadUserData () {
      const userId = this.$route.params.userId

      this.$http.get(`users/${userId}?admin=true`)
        .then(response => {
          if (response.data.data) {
            this.userData = response.data.data.user
            this.authData = response.data.data.auth
            const pictureId = this.userData.profile_picture || 'default'
            this.userData.photoURL = `https://portal-cdn.rapid.education/profile-pictures/${pictureId}.jpeg`
            this.loadUserProgress()
            this.loadGroupData(this.userData.groups)
          }
        })
        .catch(error => {
          if (error.response.status === 404) {
            this.userNotFound = true
          }
        })
    },
    loadGroupData (groups) {
      const newGroups = []
      groups.forEach(item => {
        this.$http.get(`groups/${item}`)
          .then(response => {
            if (response.data) {
              newGroups.push(response.data.data)
            }
          })
      })
      this.groupData = newGroups
      this.addStudentGroupKey++

    }
  },
  created () {
    this.addStudentCourseSearch('')
    this.addStudentGroupSearch('')
    this.loadUserData()
  },
  beforeDestroy () {
    this.userData = null
    this.activeCourseData = null
  }
}
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {

  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }

  @media (min-width: 1200px) and (max-width: 1700px) {
    .image-course {
      display: none;
    }
    .course-col {
      width: 0 !important;
      min-height: 2.05vh;
    }
    .welcome-col {
      width: 100% !important;
    }
  }
}

.datepicker-user-popup {
  .vdp-datepicker__calendar {
    width: 100%;
    padding: 5px 0 10px 0;
  }


  span.cell.day {
    border-radius: 5%;
    margin-bottom: 0.5%;
    margin-top: 0.5%;
  }

  span.cell.day.today {
    border-radius: 5%;
    color: #fff;
    background: rgba(var(--vs-primary), 0.1);

    &:hover {
      background: rgba(var(--vs-primary), 0.2);
    }
  }


}
</style>
